import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';

/**
 * Selection Column Component
 * Provides checkbox column for row selection in Smart Grid
 */
@Component({
  selector: 'app-selection-column',
  standalone: true,
  imports: [CommonModule, MatCheckboxModule],
  template: `
    <mat-checkbox
      [checked]="checked"
      [indeterminate]="indeterminate"
      [disabled]="disabled"
      [color]="'primary'"
      (change)="onCheckboxChange($event)"
      (click)="$event.stopPropagation()"
      class="selection-checkbox">
    </mat-checkbox>
  `,
  styles: [`
    .selection-checkbox {
      @apply flex items-center justify-center;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectionColumnComponent {
  /**
   * Whether the checkbox is checked
   */
  @Input() checked: boolean = false;

  /**
   * Whether the checkbox is in indeterminate state (for select all when some rows selected)
   */
  @Input() indeterminate: boolean = false;

  /**
   * Whether the checkbox is disabled
   */
  @Input() disabled: boolean = false;

  /**
   * Emits when checkbox state changes
   */
  @Output() selectionChange = new EventEmitter<boolean>();

  /**
   * Handles checkbox change event
   */
  onCheckboxChange(event: any): void {
    this.selectionChange.emit(event.checked);
  }
}
